import { GroupCard } from "./group-card"
import { useGroups } from "../hooks/use-groups"

export function GroupsGrid() {
  const { data: groups } = useGroups()

  return (
    <div className="flex flex-col gap-s">
      {groups.map((group) => (
        <GroupCard key={group.id} group={group} />
      ))}
    </div>
  )
}
